import { render, staticRenderFns } from "./_popupBanner.vue?vue&type=template&id=0a8923e8&scoped=true&lang=pug&"
import script from "./_popupBanner.vue?vue&type=script&lang=js&"
export * from "./_popupBanner.vue?vue&type=script&lang=js&"
import style0 from "./_popupBanner.vue?vue&type=style&index=0&id=0a8923e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8923e8",
  null
  
)

export default component.exports